import TriStateCheckboxTreeNodeRenderer from "./TriStateCheckboxTreeNodeRenderer";
import DisabledNodesParentTreeNode from "./DisabledNodesParentTreeNode";

export default class HierarchySelectorNodeRenderer extends TriStateCheckboxTreeNodeRenderer {
    constructor(tree, selectorFilter) {
        super(tree);
        this.selectorFilter = selectorFilter;
        this.disabledClassName = 'disabledNode';
    }

    updateUI(treeNode) {
        super.updateUI(treeNode);

        const uiObject = this.tree.getUIObjectForNode(treeNode);
        let shouldUpdateLabel = false;
        if (this.selectorFilter.containsTokens(treeNode)) {
            shouldUpdateLabel = true;
            uiObject.hasHighlight = true;
        }
        else if (uiObject.hasHighlight) {
            shouldUpdateLabel = true;
            delete uiObject.hasHighlight;
        }
        else if (treeNode instanceof DisabledNodesParentTreeNode) {
            shouldUpdateLabel = true;
        }

        if (shouldUpdateLabel)
            this.updateLabel(treeNode);
    }

    getNodeClasses(treeNode) {
        const classes = super.getNodeClasses(treeNode);
        if (this.isNeedToPushDisabledClass(treeNode)) {
            classes.push(this.getDisabledClassName());
        }
        if (treeNode.children.length === 0 && treeNode.level === 1) {
            classes.push('childlessNode');
        }
        return classes;
    }

    isNeedToPushDisabledClass(treeNode) {
        return false;
    }

    getDisabledClassName() {
        return this.disabledClassName;
    }

    getTitle(entity) {
        //abstract
    }
}



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/HierarchySelectorNodeRenderer.js